import React from 'react'
import { usePlaceholder } from 'interfaces-core'
import { Link } from 'react-router-dom'


import style from '../../../all.module.css'

const ActionAWeb3ButtonSmall  = (props) => {
    return (

        <div className={style.ActionAWeb3ButtonSmall}>
            <button className={style.ActionAWeb3ButtonSmall}>Claim</button>
        </div>

    )
}

    export default ActionAWeb3ButtonSmall